import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '../../../shared/utils/base.component';
import { SectionsService } from '../../../services/sections.service';
import { STATIC_JSON_DATA_PATH } from '../../../shared/constants/static-data.constants';
import { LoggerService } from '../../../shared/services/logger.service';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { TableRowActions } from '../../../shared/interfaces/actions';
import { TableRowActionsModel } from '../../../shared/interfaces/list.interface';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { LeadDetailsService } from '../../../services/lead-details.service';
import {
  DialogConfig,
  DialogService,
} from '../../../shared/services/dialog.service';
import { ButtonComponent } from '../../../shared/components/button/button.component';

@Component({
  selector: 'ppl-login-details',
  standalone: true,
  imports: [CommonModule, ListTableComponent, ButtonComponent],
  templateUrl: './login-details.component.html',
  styleUrl: './login-details.component.css',
})
export class LoginDetailsComponent extends BaseComponent implements OnInit {
  @Input() pageId = '';
  @Input() tabId = '';
  @Input() program: any;
  @Input() readOnly = false;
  @Input() selectedLeadId: any;
  @Input() entry: any;
  @Input() displayMode: 'table' | 'card' = 'table';
  @Output() leadUpdated = new EventEmitter<boolean>();
  @Output() hasData = new EventEmitter<boolean>();
  @Output() loginDataChange = new EventEmitter<{ userRoleActive?: string; azureUUID?: string; userId?: string }[]>();
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;

  cols: any;
  loginData = [];
  isSectionEditable = true;
  private dialogSvc = inject(DialogService);
  actionButtons: TableRowActionsModel = new TableRowActions({ delete: true });

  constructor(
    private sectionService: SectionsService,
    private logger: LoggerService,
    private authUtility: AuthorizationUtility,
    private leadDetailsService: LeadDetailsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.isSectionEditable = this.readOnly
      ? false
      : this.authUtility.isSectionEditable(
          this.pageId,
          this.tabId,
          'Usernames'
        );
    this.getColumns();
    this.getLoginData();
  }

  get cardDetailCols(): { field: string; header: string }[] {
    return (this.cols || []).filter(
      (col: { field: string }) => col.field !== 'userName'
    );
  }

  async getColumns() {
    try {
      if (this.entry) {
        const tempCols = await this.sectionService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.LEAD_DETAILS_CONTACT_LIST_HEADERS,
          this.entry
        );
        this.cols = tempCols.loginDetails.columns;
      }
    } catch (e) {
      this.logger.debug('Error in getting column data', e);
    }
  }

  formatResponse(data: any[]) {
    if (data) {
      const copyData = JSON.parse(JSON.stringify(data));
      copyData.forEach((data: any) => {
        const isActive = data.userRoleActive.toLowerCase() === 'yes';
        data.actions = {
          delete: isActive,
        };
      });
      this.loginData = copyData;
    }
    this.hasData.emit(!!this.loginData?.length);
    this.loginDataChange.emit(this.loginData);
  }

  getLoginData() {
    if (!this.selectedLeadId) {
      return;
    }
    const payload = {
      programCode: this.program ? this.program.program_code : 'NY',
      participantId:
        this.entry === 'participantEnrollment' ? this.selectedLeadId : null,
      providerId:
        this.entry === 'providerEnrollment' ? this.selectedLeadId : null,
    };
    this.leadDetailsService.getLoginDetails(payload).subscribe((data: any) => {
      this.formatResponse(data.responsedata);
    });
  }

  deleteUserRole(userData: any) {
    const payload = {
      azureUUID: userData.azureUUID
    }
    this.leadDetailsService
      .deleteAuthUserRole(userData.userRoleId, payload)
      .subscribe((data: any) => {
        if (data.status === 200) {
          this.getLoginData();
        }
      });
  }

  action(event: any) {
    if (event.action === 'delete') {
      this.openConfirmationPopup(event.data);
    }
  }

  handleCancel() {}

  openConfirmationPopup(data: any) {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      isOkText: 'Ok',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.confirmationDialog,
      dialogConfig,
      () => this.deleteUserRole(data),
      () => this.handleCancel()
    );
  }
}
